import React, { useState } from "react";
import { Container, Row, Image, Button, Col } from "react-bootstrap";
import LeftSideNavigation from "../../../navigationSection/LeftSideNavigation";
import RightSideNavigation from "../../../navigationSection/RightSideNavigation";
import BottomNavigationMobile from "../../../navigationSection/BottomNavigationMobile";
import { TopNavigationBarMobile } from "../../../navigationSection/TopNavigationBarMobile";
import AddWalkInWait from "../../../seatingDashboard/AddWalkInWait";
import AddReservation from "../../../seatingDashboard/AddReservation";

const AddEvent = () => {
  const [selectedPage, setSelectedPage] = useState(1);
  const onPageChange = (value) => (e) => {
    setSelectedPage(value);
  };

  return (
    <React.Fragment>
      <Container fluid>
        <Row>
          <div className="left-side-panel">
            <LeftSideNavigation />
          </div>
          <div className="top-panel">
            <TopNavigationBarMobile displayLeft="logo" />
          </div>
          <div className="right-side-panel">
            <RightSideNavigation />
            <div className="f24_700_HelveticaNeue pb-4">Add Guest</div>
            <Row>
              <Col md={6}>
                <span style={{ fontWeight: "bold" }}>
                  Sonali Wedding Event{" "}
                </span>
                <span
                  className="badge badge-warning"
                  style={{ padding: "5px 15px" }}
                >
                  Offline
                </span>
                <br />
                <span style={{ color: "#EE3A23" }}>Event ID: 123434343</span>
                <br />
                <span style={{ color: "#9E9E9E", fontSize: "8px" }}>
                  These imply that the net payment is due in either 7, 10, 30,
                  60, or 90 days after the ... invoice date.
                </span>
              </Col>
              <Col md={3}>
                Dates <br />
                <b> 31st August 2019</b>
              </Col>
              <Col md={3}>
                Time
                <br />
                <b> 05:00 PM - 10:00 PM</b>
              </Col>
            </Row>
            <div className="d-flex align-items-start">
              <Button
                variant="link"
                className={`enAddOffersOPtion d-flex flex-column align-items-center mr-5 ${
                  selectedPage === 1 ? "active" : ""
                }`}
                onClick={onPageChange(1)}
              >
                <Image
                  src={
                    selectedPage === 1
                      ? require("../../../../../assets/images/ActionImages/1/walkActive.svg")
                      : require("../../../../../assets/images/ActionImages/1/walk.svg")
                  }
                  alt="View"
                  title="View"
                  fluid
                />
                <span className="active f12-400 d-block w-100 mb-2">RSVP</span>
              </Button>
              <Button
                variant="link"
                className={`enAddOffersOPtion d-flex flex-column align-items-center ml-3 ${
                  selectedPage === 2 ? "active" : ""
                }`}
                onClick={onPageChange(2)}
              >
                <Image
                  src={
                    selectedPage === 2
                      ? require("../../../../../assets/images/ActionImages/1/ReservationsActive.svg")
                      : require("../../../../../assets/images/ActionImages/1/Reservations.svg")
                  }
                  alt="View"
                  title="View"
                  fluid
                />
                <span className="active f12-400 d-block w-100 mb-2">
                  Ticket Booked
                </span>
              </Button>
            </div>
            <hr />
            {selectedPage === 1 && <AddWalkInWait />}
            {selectedPage === 2 && <AddReservation />}
          </div>
          <div className="bottom-panel">
            <BottomNavigationMobile />
          </div>
        </Row>
      </Container>
    </React.Fragment>
  );
};
export default AddEvent;
